module.exports = __webpack_public_path__ + "img/zaluzie-rolety.db3f8bb2.svg";